// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plan-holding-content[data-v-2d1be5d5]{font-size:16px;color:#eb3d3b}.label[data-v-2d1be5d5]{color:#777;font-size:14px}.creditcard-number[data-v-2d1be5d5],.payment-creditcard[data-v-2d1be5d5]{font-size:16px}", ""]);
// Exports
module.exports = exports;
